import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { HeadingL, HeadingXL } from "../Typography";

export const Root = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 7,
    }),
);

export const Section = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 0,
    }),
);

export const PortalTitle = styled(HeadingXL)(({ theme }) =>
    theme.unstable_sx({}),
);

export const ClientName = styled(HeadingL)(({ theme }) =>
    theme.unstable_sx({}),
);

export const LoadingName = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({}),
);